import { Suspense } from 'react'
import { recoverableLazy } from '@/components/ModuleRecovery/ModuleRecovery'
import { Icon } from '@iconify/react'
import styles from './Shop.module.css'

const ShopCatalogDialog = recoverableLazy(() => import('./ShopCatalogDialog'))

export function ShopLauncher({
  campaignId,
  institutionName,
  open,
  onOpen,
  onClose,
}: {
  campaignId: number
  institutionName: string
  open: boolean
  onOpen: () => void
  onClose: () => void
}) {
  return (
    <>
      <button type="button" className={styles.launcher} onClick={onOpen}>
        <span className={styles.launcherIcon}>
          <Icon icon="mdi:shopping-outline" width={28} />
        </span>
        <span>
          <strong>Loja</strong>
          <small>Explore nosso Clube de Ofertas</small>
        </span>
        <Icon icon="mdi:arrow-top-right" width={24} />
      </button>
      {open && (
        <Suspense fallback={<p role="status">Abrindo Loja…</p>}>
          <ShopCatalogDialog
            campaignId={campaignId}
            institutionName={institutionName}
            onClose={onClose}
          />
        </Suspense>
      )}
    </>
  )
}
